import ChangePassword from "../../components/admin/change-password";

const ChangePasswordPage: React.FC = () => {
    return <ChangePassword/>
}

export default ChangePasswordPage;